import React from "react";
import styled from "styled-components";

import Button from "../../../_components/Button";
import Table from "../../../_components/TableData";
import Page from "../../../_components/Page";
import LoadingInput from "../../../_components/LoadingInput";
import Modal from "../../../_components/Modal";
import { filter } from "../../../api/nfce";
import Text from "../../../_components/Text";
import { formatCurrencyValue, formatDate, donwloadBase64 } from "../../../utils";

import * as colors from "../../../assets/_base/colors"
import DownloadReport from "../NFe/List/DownloadReport";

import { cancelSale } from "../../../api/sales"
import IconButton from "../../../_components/IconButton";
import { toast } from "react-toastify";
import Dropdown, { DropDownDivider, DropDownItem } from "../../../_components/Dropdown";
import { downaloadDANFE, getNFeBase64 } from "../../../api/nfe";
import { toast as toastify } from "react-toastify"


const NFCE_STATUS_CHOICES = {
  "1": "Autorizado",
  "2": "Cancelado",
}
const NFCE_STATUS_COLORS = {
  "1": colors.success,
  "2": colors.dark,
}

export default (props) => {
  const [tableHeaderFields, setTableHeaderFields] = React.useState({
    header: [
      "Situação",
      "Data da Venda",
      "Numeração",
      "Série",
      "Valor",
      "Desconto",
      "Total",
      "Cliente",
      "Ações",
    ],
    body: [
      "status",
      "created_date",
      "number",
      "series",
      "value",
      "discount",
      "paid_value",
      "client_name",
      "actions",
    ],
  });
  const [params, setParams] = React.useState({})
  const [data, setData] = React.useState([]);
  const [modalFilter, showModalFilter] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  function onChange(e) {
    setParams({
      [e.target.name]: e.target.value
    })
  }

  function onFilter() {
    filter(params).then((resp) => {
      resp = resp.map((nfce) => {
        return {
          ...nfce,
          status: <bold style={{ fontWeight: 'bold', color: NFCE_STATUS_COLORS[nfce.status] }}>{NFCE_STATUS_CHOICES[nfce.status]}</bold>,
          value: formatCurrencyValue(nfce.value),
          paid_value: formatCurrencyValue(nfce.paid_value),
          discount: formatCurrencyValue(nfce.discount),
          created_date: formatDate(nfce.created_date),
          actions: <div className="d-flex justify-content-between">

            <Button
              as="text"
              disabled={loading}
              onClick={() => { downloadPDF(nfce) }}
            >
              {loading ? <i class="fas fa-spinner fa-pulse text-danger" /> : <i className="fa fa-file-pdf text-danger" />}
            </Button>

            <Button
              as="text"
              disabled={loading}
              onClick={() => { downloadXML(nfce) }}
            >
              {loading ? <i class="fas fa-spinner fa-pulse text-danger" /> : <i className="fa fa-file-code text-success" />}
            </Button>

            <Dropdown>

              <DropDownItem>
                <Button
                  as="text"
                  className="text-dark mx-1"
                  onClick={() => { window.location.href = `/sale/${nfce.sale}` }}
                >
                  <i className="fas fa-eye" />{" "}
                  <span>Ver venda</span>
                </Button>
              </DropDownItem>

              <DropDownDivider />

              <DropDownItem>
                <Button
                  as="text"
                  className="text-dark mx-1"
                  onClick={() => { downloadPDF(nfce) }}
                >
                  <i className="fa fa-file-pdf" />{" "}
                  <span>Baixar PDF</span>
                </Button>
              </DropDownItem>

              <DropDownDivider />

              <DropDownItem>
                <Button
                  as="text"
                  className="text-dark mx-1"
                  onClick={() => { downloadXML(nfce) }}
                >
                  <i className="fa fa-file-code" />{" "}
                  <span>Baixar XML</span>
                </Button>
              </DropDownItem>

              <DropDownDivider />

              <DropDownItem>
                <Button
                  as="text"
                  className="text-danger mx-1"
                  onClick={() => onCancelSale(nfce)}
                >
                  <i className="fas  fa-trash-alt" />{" "}
                  <span>Cancelar NFCe</span>
                </Button>
              </DropDownItem>

            </Dropdown>


          </div>
        };
      });
      setData(resp)
      showModalFilter(false)
    });
  }

  function onCancelSale(nfce) {
    cancelSale(nfce.sale)
      .then(() => {
        toast.success('NFCe Cancelada com sucesso!', { position: "top-center" })
        setTimeout(() => {
          window.location.reload()
        }, 1000);
      })
      .catch(error => {
        console.log(error[0])
        if (error[0] == 'A sale must be confirmed (status = 2) to be cancelled.') {
          toast.error('A NFCe ja está autorizada.', { position: "top-center" })
          return
        }
        toast.error(error[0], { position: "top-center" })
      })
  }

  function downloadPDF(nfce) {
    setLoading(true)

    getNFeBase64({
      key: nfce.key,
      document: "nfce"
    }).then(resp => {

      const LinkSource = `data:application/pdf;base64,${resp.pdf}`;
      const LinkSource2 = `data:application/xml;base64,${resp.xml}`;
      console.log('LinkSource2LinkSource2', LinkSource2)
      const DownloadLink = document.createElement('a');
      const DownloadLink2 = document.createElement('a');
      DownloadLink.href = LinkSource;
      DownloadLink2.href = LinkSource2;
      DownloadLink.download = `${nfce.key}.pdf`;
      DownloadLink2.download = `${nfce.key}.xml`;
      DownloadLink.click();
      DownloadLink2.click();

      donwloadBase64(nfce.key, "pdf", "application/pdf", resp)
        .then(resp => {
          console.log(resp)
        })

        .catch(error => console.log(error))

    }).finally(() => {

    })

  }

  function downloadXML(nfce) {
    setLoading(true)

    getNFeBase64({
      key: nfce.key,
      document: "nfce"
    }).then(resp => {

      const LinkSource2 = `data:application/xml;base64,${resp.xml}`;
      const DownloadLink2 = document.createElement('a');
      DownloadLink2.href = LinkSource2;
      DownloadLink2.download = `${nfce.key}.xml`;
      DownloadLink2.click();

      donwloadBase64(nfce.key, "xml", "application/xml", resp)
        .then(resp => {
          console.log(resp)
        })

        .catch(error => {
          console.log(error)
        })

    }).catch(error => {
      if (error.partner_error) {
        toastify.error("Documento não localizado", { position: "top-center" })

      }

    })

  }

  React.useEffect(onFilter, [])

  return (
    <Page default={false} loading={loading}>
      <div className="">
        <h1 className="text-center h2">NFCe</h1>
        <div className=""><Button onClick={() => showModalFilter(true)}>Exibir Filtros</Button></div>
        <div className="d-flex justify-content-end">
        <DownloadReport icon request={filter} params={params} />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Table
            tHead={tableHeaderFields.header}
            tBodyKeys={tableHeaderFields.body}
            data={data}
          />
        </div>
      </div>
      <Modal title='Filtro NFC-e' show={modalFilter} onHide={() => showModalFilter(false)}>
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <Text>Nome do Cliente</Text>
            <LoadingInput name="client" onChange={onChange} placeholder='Insira um valor' />
          </div>
          <div className="col-lg-6 col-sm-12">
            <Text>Series</Text>
            <LoadingInput name="series" onChange={onChange} type="number" min="1" placeholder='Insira um valor' />
          </div>
          <div className="col-lg-6 col-sm-12">
            <Text>Número Inicial</Text>
            <LoadingInput name="start_number" onChange={onChange} type="number" min="1" placeholder='Insira um valor' />
          </div>
          <div className="col-lg-6 col-sm-12">
            <Text>Número Final</Text>
            <LoadingInput name="end_number" onChange={onChange} type="number" min="0" placeholder='Insira um valor' />
          </div>
          <div className="col-lg-6 col-sm-12">
            <Text>Data Inicial</Text>
            <LoadingInput name="start_date" onChange={onChange} type="date" placeholder='Insira um valor' />
          </div>
          <div className="col-lg-6 col-sm-12">
            <Text>Data Final</Text>
            <LoadingInput name="end_date" onChange={onChange} type="date" placeholder='Insira um valor' />
          </div>
          <div className="col-lg-6 col-sm-12">
            <Text>Exibir até:</Text>
            <LoadingInput name="end_count" onChange={onChange} as="select" >
              {[10, 20, 30, 40, 50, 100, 200].map((count, _) => <option key={`select_count_${_}`} value={count} >{count} notas</option>)}
            </LoadingInput>
          </div>
        </div>
        <Button className='text-right' onClick={onFilter}>Pesquisar</Button>
      </Modal>
    </Page>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFCe/index.jsx